export default {
      id: "icon-alarm-usage",
      viewBox: "0 0 30.222 30.223",
      url: __webpack_public_path__ + "icons.svg#icon-alarm",
      toString: function () {
        return this.url;
      }
    }